<template>
    <!-- DESCR：会议论文详细描述页面 -->
    <div class="detailpaper-box">
        <!-- 页面信息描述 -->
        <el-row justify="center">
            <el-col :span="21" class="login-title">
                <div class="desc-box">
                    <div class="title">{{ $route.query.acronym }} Submission {{ paperinfo.autoid }}</div>
                    <br />
                    <div class="info">
                        Here is the detailed information for paper submission, where you can preview or print PDF files
                        online
                    </div>
                    <div class="info">
                        If you are a contributor, you can refer to the paper you have submitted
                    </div>
                    <div class="info">
                        If you are a reviewer, you can comment on your paper's views here
                    </div>
                    <div class="info">
                        If you are the chairman, you can see the status of the paper approval process
                    </div>
                </div>
            </el-col>
            <el-col :span="3" class="login-title" style="display: flex;align-items: center;justify-content: center;"
                size="small" @click="$router.back()">
                <el-button type="primary" :icon="ArrowLeftBold" circle plain v-if="pagenum>1"></el-button>
            </el-col>
        </el-row>
        <el-row :gutter="10" justify="center" v-if="$route.query.role == '3'">
            <el-col :span="24" style="margin-top:10px;margin-bottom:50px">
                <div class="authorbtn status">
                    <h4 class="section">审批状态</h4>
                </div>
                <!-- 正常流程审批流（主席） -->
                <el-steps :active="paperinfo.status == 4 ? paperinfo.status + 1 : paperinfo.status" align-center
                    finish-status="success">
                    <el-step title="Submitted" description="author submits paper"></el-step>
                    <el-step title="To be pushed" description="chairman's push for review"></el-step>
                    <el-step title="Pending review" description="paper review stage"
                        v-if="!(paperinfo.status == 1 && paperinfo.isTermination == 1)"></el-step>
                    <el-step title="Pending decision" description="makes decisions"
                        v-if="!(paperinfo.status == 1 && paperinfo.isTermination == 1) && !(paperinfo.status == 2 && paperinfo.isTermination == 1)"></el-step>
                    <el-step title="End" description="final status of the paper"
                        v-if="(paperinfo.status < 4) && paperinfo.isTermination == 0"></el-step>
                    <el-step title="Rejected manuscript" description="has been rejected" status="error" v-if="paperinfo.isTermination == 1"></el-step>
                    <el-step title="Has been accepted" description="has been accepted" status="success"
                        v-if="paperinfo.status == 4 && paperinfo.isTermination == 0"></el-step>
                </el-steps>
            </el-col>
        </el-row>
        <!-- 论文详细信息 -->
        <el-row :gutter="10" justify="center">
            <el-col :span="24">
                <el-descriptions column="1" border direction="vertical">
                    <template #title>
                        <h4 class="section">Detailed paper</h4>
                    </template>
                    <el-descriptions-item label="Title:" width="160" label-class-name="my-label">{{ paperinfo.title
                    }}</el-descriptions-item>
                    <el-descriptions-item label="Submission:" label-class-name="my-label">
                        <div style="display:flex;align-items: center;cursor: pointer;" @click="centerDialogVisible = true">
                            <el-icon style="font-size:18px;margin-right:5px">
                                <document />
                            </el-icon>
                            <div>click view file</div>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="Author keywords" label-class-name="my-label">
                        <div style="white-space: pre-line;">
                            {{ paperinfo.authorkeywords }}
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="Abstract:" label-class-name="my-label">{{ paperinfo.abstractinfo }}
                    </el-descriptions-item>
                    <el-descriptions-item label="Submitted:" label-class-name="my-label">{{ paperinfo.createtime }}
                    </el-descriptions-item>
                    <el-descriptions-item label="Last update:" label-class-name="my-label">{{ paperinfo.updatetime }}
                    </el-descriptions-item>
                    <el-descriptions-item label="Decision:" label-class-name="my-label"
                        v-if="$route.query.role == '3' && paperinfo.status == 4 && paperinfo.isTermination != 1"><el-tag
                            size="small" type="success">ACCEPT</el-tag></el-descriptions-item>
                    <el-descriptions-item label="Decision:" label-class-name="my-label"
                        v-else-if="$route.query.role == '3' && paperinfo.isTermination == 1"><el-tag size="small"
                            type="danger">REJECT</el-tag></el-descriptions-item>
                    <el-descriptions-item label="Decision:" label-class-name="my-label"
                        v-else-if="$route.query.role == '3'"></el-descriptions-item>
                    <el-descriptions-item label="Subreviewers" label-class-name="my-label" v-if="$route.query.role == '3'">
                        <div v-for="item, index in paperinfo.subList" :key="index">
                            <div style="margin-bottom: 10px;">
                                <el-tag size="small">{{ item.firstname2 }} {{ item.lastname2 }} &lt;{{ item.email2 }}&gt;
                                    ({{ item.firstname1 }} {{ item.lastname1 }},<span
                                        v-if="item.isAccept >= 2">done</span><span v-else>unknown</span>)</el-tag>
                            </div>
                        </div>
                    </el-descriptions-item>
                </el-descriptions>
                <el-table :data="paperinfo.authorList" strip border>
                    <el-table-column prop="firstname" label="firstname" width="130" align="center"></el-table-column>
                    <el-table-column prop="lastname" label="last name" width="130" align="center"></el-table-column>
                    <el-table-column prop="email" label="email" align="center" width="200"></el-table-column>
                    <el-table-column prop="country" label="country" width="130" align="center"></el-table-column>
                    <el-table-column prop="affiliation" label="affiliation" align="center"></el-table-column>
                    <el-table-column prop="webpage" label="Web page" width="150" align="center"></el-table-column>
                    <el-table-column label="corresponding?" align="center" width="180">
                        <template #default="scope">
                            <el-checkbox v-model="scope.row.isCorresponding" :checked="scope.row.isCorresponding == 1"
                                disabled></el-checkbox>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <div>
            <!-- 角色分配，审稿者评论意见权 -->
            <el-row :gutter="10" v-if="$route.query.role == '2' && paperinfo.status == 2">
                <el-col :span="16" style="margin-top: 50px;">
                    <div>
                        <el-descriptions column="1" border>
                            <template #title>
                                <h4 class="section">Email</h4>
                            </template>
                            <el-descriptions-item label="Time:" width="160" class-name="email-item"
                                label-class-name="email-item">
                                <el-text class="mx-1">{{ paperinfo.email.time1 }}</el-text>
                            </el-descriptions-item>
                            <el-descriptions-item label="Who:" width="160" class-name="email-item"
                                label-class-name="email-item">
                                <el-text class="mx-1">{{ paperinfo.email.who1 }}</el-text>
                            </el-descriptions-item>
                            <el-descriptions-item label="Subject:" width="160" class-name="email-item"
                                label-class-name="email-item">
                                <el-text class="mx-1">{{ paperinfo.email.subject1 }}</el-text>
                            </el-descriptions-item>

                        </el-descriptions>
                        <div class="msg-box">
                            {{ paperinfo.email.message1 }}
                        </div>
                    </div>
                    <div v-if="paperinfo.email.time2">
                        <el-descriptions column="1" border>
                            <el-descriptions-item label="Time:" width="160" class-name="email-item"
                                label-class-name="email-item">
                                <el-text class="mx-1">{{ paperinfo.email.time2 }}</el-text>
                            </el-descriptions-item>
                            <el-descriptions-item label="Who:" width="160" class-name="email-item"
                                label-class-name="email-item">
                                <el-text class="mx-1">{{ paperinfo.email.who2 }}</el-text>
                            </el-descriptions-item>
                            <el-descriptions-item label="Subject:" width="160" class-name="email-item"
                                label-class-name="email-item">
                                <el-text class="mx-1">{{ paperinfo.email.subject2 }}</el-text>
                            </el-descriptions-item>

                        </el-descriptions>
                        <div class="msg-box">
                            {{ paperinfo.email.message2 }}
                        </div>
                    </div>
                </el-col>
            </el-row>
            <!-- 审稿意见信息 -->
            <el-row :gutter="10" justify="center" v-if="paperinfo.adviceList?.length != 0">
                <el-col :span="24" style="padding-right:230px">
                    <div class="authorbtn">
                        <h4 class="section">Review comments</h4>
                    </div>
                    <div class="reviews" v-for="advItem, index in paperinfo.adviceList" :key="advItem.id">
                        <div class="title">Review {{ index + 1 }}</div>
                        <el-descriptions border column="1" direction="vertical" size="small">
                            <el-descriptions-item width="260" label-class-name="my-label">
                                <template #label>
                                    <div>Paper</div>
                                </template>
                                <div>
                                    {{ paperinfo.autoid }}
                                </div>
                            </el-descriptions-item>
                            <el-descriptions-item width="260" label-class-name="my-label">
                                <template #label>
                                    <div>Title</div>
                                </template>
                                <div>
                                    {{ advItem.title }}
                                </div>
                            </el-descriptions-item>
                            <el-descriptions-item width="260" label-class-name="my-label">
                                <template #label>
                                    <div>Authors</div>
                                </template>
                                <div>
                                    {{ advItem.authors }}
                                </div>
                            </el-descriptions-item>
                            <el-descriptions-item width="260" label-class-name="my-label">
                                <template #label>
                                    <div>PC member</div>
                                </template>
                                <div>
                                    {{ advItem.member }}
                                </div>
                            </el-descriptions-item>
                            <el-descriptions-item width="260" label-class-name="my-label">
                                <template #label>
                                    <div>Reviewer</div>
                                </template>
                                <div>
                                    {{ advItem.reviewer }}
                                </div>
                            </el-descriptions-item>
                            <el-descriptions-item width="260" label-class-name="my-label">
                                <template #label>
                                    <div>Time</div>
                                </template>
                                <div>
                                    {{ advItem.createtime }}
                                </div>
                            </el-descriptions-item>
                            <el-descriptions-item width="260" label-class-name="my-label">
                                <template #label>
                                    <div>Overall evaluation</div>
                                </template>
                                <div>
                                    <div style="margin-bottom:4px;font-size:15px;font-weight:700">{{ advItem.score1 }}: {{
                                        cities.find((item) => item.value == advItem.score1).label }}
                                    </div>
                                    <div>
                                        {{ advItem.reason }}
                                    </div>
                                </div>
                            </el-descriptions-item>
                            <el-descriptions-item width="260" label-class-name="my-label">
                                <template #label>
                                    <div>Reviewer's confidence</div>
                                </template>
                                <div>
                                    <div style="margin-bottom:4px;font-size:15px;font-weight:700">{{ advItem.score2 }}: {{
                                        cities2.find((item) => item.value == advItem.score2).label }}
                                    </div>
                                </div>
                            </el-descriptions-item>
                            <el-descriptions-item width="260" label-class-name="my-label">
                                <template #label>
                                    <div>Confidential remarks for the program committee</div>
                                </template>
                                <div>
                                    {{ advItem.remarks }}
                                </div>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 角色分配，主席决策权（状态>2,至少为待决策阶段才显示修改、录用） -->
        <el-row :gutter="10" justify="center" v-if="$route.query.role == '3'">
            <el-col :span="21" style="display:flex;justify-content: center;margin-top:30px">
                <el-button type="success" style="width:150px;margin-right: 20px;"
                    :disabled="paperinfo.status == 4 || paperinfo.isTermination == 1" @click="hire"
                    v-if='paperinfo.status > 2'>Accept</el-button>
                <el-button type="danger" style="width:150px"
                    :disabled="paperinfo.status == 4 || paperinfo.isTermination == 1" @click="refuse"
                    v-if='paperinfo.status > 0'>Reject</el-button>
            </el-col>
        </el-row>
        <!-- 我的意见信息 -->
        <el-row :gutter="10" justify="center" v-if="adviceform.createtime">
            <el-col :span="24" style="padding-right:230px">
                <div class="authorbtn">
                    <h4 class="section">Your Review</h4>
                </div>
                <div class="reviews">
                    <div class="title">Review 1</div>
                    <el-descriptions border column="1" direction="vertical" size="small">
                        <el-descriptions-item width="260" label-class-name="my-label">
                            <template #label>
                                <div>Paper</div>
                            </template>
                            <div>
                                {{ adviceform.pid }}
                            </div>
                        </el-descriptions-item>
                        <el-descriptions-item width="260" label-class-name="my-label">
                            <template #label>
                                <div>Title</div>
                            </template>
                            <div>
                                {{ adviceform.title }}
                            </div>
                        </el-descriptions-item>
                        <el-descriptions-item width="260" label-class-name="my-label">
                            <template #label>
                                <div>Authors</div>
                            </template>
                            <div>
                                {{ adviceform.authors }}
                            </div>
                        </el-descriptions-item>
                        <el-descriptions-item width="260" label-class-name="my-label">
                            <template #label>
                                <div>PC member</div>
                            </template>
                            <div>
                                {{ adviceform.member }}
                            </div>
                        </el-descriptions-item>
                        <el-descriptions-item width="260" label-class-name="my-label">
                            <template #label>
                                <div>Reviewer</div>
                            </template>
                            <div>
                                {{ adviceform.reviewer }}
                            </div>
                        </el-descriptions-item>
                        <el-descriptions-item width="260" label-class-name="my-label">
                            <template #label>
                                <div>Time</div>
                            </template>
                            <div>
                                {{ adviceform.createtime }}
                            </div>
                        </el-descriptions-item>
                        <el-descriptions-item width="260" label-class-name="my-label">
                            <template #label>
                                <div>Overall evaluation</div>
                            </template>
                            <div>
                                <div style="margin-bottom:4px;font-size:15px;font-weight:700">{{ adviceform.score1 }}: {{
                                    cities.find((item) => item.value == adviceform.score1)?.label }}
                                </div>
                                <div>
                                    {{ adviceform.reason }}
                                </div>
                            </div>
                        </el-descriptions-item>
                        <el-descriptions-item width="260" label-class-name="my-label">
                            <template #label>
                                <div>Reviewer's confidence</div>
                            </template>
                            <div>
                                <div style="margin-bottom:4px;font-size:15px;font-weight:700">{{ adviceform.score2 }}: {{
                                    cities2.find((item) => item.value == adviceform.score2)?.label }}
                                </div>
                            </div>
                        </el-descriptions-item>
                        <el-descriptions-item width="260" label-class-name="my-label">
                            <template #label>
                                <div>Confidential remarks for the program committee</div>
                            </template>
                            <div>
                                {{ adviceform.remarks }}
                            </div>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
            </el-col>
        </el-row>
        <!-- 隐藏层 -->
        <!-- 文档预览弹出层 -->
        <div class="office-dia">
            <el-dialog v-model="centerDialogVisible" title="Paper preview" width="70%" center draggable top="5vh">
                <el-scrollbar height="500px" v-loading="loading">
                    <vue-office-pdf ref="pdfView" :src="pdf" @rendered="rendered" class="myoffice" />
                </el-scrollbar>
                <template #footer>
                    <span class="dialog-footer">
                        <el-button @click="printpdf">Print</el-button>
                        <el-button type="primary" @click="download">Download</el-button>
                    </span>
                </template>
            </el-dialog>
        </div>
        <!-- 回复审稿请求 -->
        <el-dialog v-model="diaRequestAccept" title="Answer request" width="55%" style="margin-top: 1%;" center>
            <el-form :model="formRequestAccept" label-width="230px" label-position="right" :rules="rules">
                <el-form-item label="Subject:" name="subject" prop="subject" required>
                    <el-input v-model="formRequestAccept.subject" autocomplete="off" />
                </el-form-item>
                <el-form-item label="Message:" name="message" prop="message" required>
                    <el-input v-model="formRequestAccept.message" autocomplete="off" type="textarea" resize="none"
                        :autosize="{ minRows: 8, maxRows: 50 }" />
                </el-form-item>
                <el-divider />
                <el-form-item label="Decision:" prop="decision" required>
                    <el-radio-group v-model="formRequestAccept.decision">
                        <el-radio label="2">I agree to review this submission</el-radio>
                        <el-radio label="3">I do not agree to review it</el-radio>
                        <el-radio label="4">I will decide later</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <el-form-item prop="type" style="padding-left: 158px;">
                <el-checkbox-group v-model="formRequestAccept.type">
                    <el-checkbox label="send email" name="isEmail" checked disabled />
                </el-checkbox-group>
            </el-form-item>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="diaRequestAccept = false" style="width: 150px;">Cancel</el-button>
                    <el-button type="primary" @click="answerRequest" style="width: 150px;">
                        Send
                    </el-button>
                </span>
            </template>
        </el-dialog>
        <!-- 回复审稿信息 -->
        <el-dialog v-model="diaSubmitreview" width="55%" style="margin-top: 1%;" center>
            <el-row :gutter="10" justify="center">
                <el-col :span="24">
                    <div class="reviews">
                        <div class="title">Submit review</div>
                        <el-descriptions border column="2">
                            <el-descriptions-item width="260">
                                <template #label>
                                    <div style="text-align:center">Overall evaluation</div>
                                </template>
                                <div style="display:flex;align-items: center;padding:10px">
                                    <el-form :model="adviceform" label-width="200px" label-position="left">
                                        <div style="display:flex">
                                            <el-form-item label="Evaluation score:" required style="width:500px;">
                                                <el-select v-model="adviceform.score1" placeholder="Please select"
                                                    :disabled="adviceform.createtime">
                                                    <el-option v-for="item in cities" :key="item.value" :label="item.label"
                                                        :value="item.value">
                                                        <span style="float: left">{{ item.label }}</span>
                                                        <span
                                                            style="float: right;color: var(--el-text-color-secondary);font-size: 13px;">{{
                                                                item.value }}</span>
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                        <br />
                                        <el-form-item label="Evaluation reason:" required>
                                            <el-input v-model="adviceform.reason" :autosize="{ minRows: 5, maxRows: 20 }"
                                                resize="none" type="textarea" :disabled="adviceform.createtime"
                                                style="width:500px" />
                                        </el-form-item>
                                        <el-form-item label="Reviewer's confidence:" style="margin-top: 30px;width: 500px;" required>
                                            <el-select v-model="adviceform.score2" placeholder="Please select"
                                                :disabled="adviceform.createtime">
                                                <el-option v-for="item in cities2" :key="item.value" :label="item.label"
                                                    :value="item.value" v-model="adviceform.committee">
                                                    <span style="float: left">{{ item.label }}</span>
                                                    <span
                                                        style="float: right;color: var(--el-text-color-secondary);font-size: 13px;">{{
                                                            item.value }}</span>
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <div style="margin-top: 20px;"><span style="font-weight:700">Confidential remarks
                                                for the program committee.</span> If you wish to add any remarks intended
                                            only for PC members please write them below. These remarks will only be seen by
                                            the PC members having access to reviews for this submission. They will not be
                                            sent to the authors. This field is optional.</div>
                                        <el-input v-model="adviceform.remarks" :autosize="{ minRows: 5, maxRows: 20 }"
                                            resize="none" type="textarea" :disabled="adviceform.createtime"
                                            style="width:100%" />
                                    </el-form>
                                </div>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="10" justify="center">
                <el-col :span="21" style="display:flex;justify-content: center;margin-top:30px">
                    <el-button type="primary" style="width:200px" @click="submitAdvice">Submit review information</el-button>
                </el-col>
            </el-row>
        </el-dialog>
        <!-- 主席请求 -->
        <div class="arq-box" v-if="$route.query.role == '3'">
            <div @click="modify">Update paper</div>
            <div @click="sendemail">Email to authors</div>
            <div @click="sendemail2" v-if="paperinfo.subList?.length!=0">Email to reviewers</div>
        </div>

        <!-- 审稿请求 -->
        <div>
            <div class="arq-box" @click="showDiaRequestAccept" v-if="adviceform.isAccept == 1">Answer request</div>
            <div class="arq-box" @click="diaSubmitreview = true"
                v-else-if="adviceform.isAccept == 2 && adviceform.createtime == null">
                Submit review</div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex"
import { Document, Plus, Delete, Download,ArrowLeftBold } from '@element-plus/icons'
import VueOfficePdf from '@vue-office/pdf'
import '@vue-office/docx/lib/index.css'
import printJS from 'print-js'
import { saveAs } from 'file-saver';
import request from "../../network/request"
import { ElMessage } from 'element-plus'
import { Icon } from '@vicons/utils'
import shortid from 'shortid';


const pagenum = window.history.length
const route = useRoute()
const router = useRouter()
// 论文详细信息
const paperinfo = ref({})
// 文件预览显示状态
const centerDialogVisible = ref(false)
// pdf文件下载链接
const pdf = ref()
// 加载状态
const loading = ref(true)
// pdf视图
const pdfView = ref(null)
// 论文建议
const adviceform = ref({
    pid: route.query.pid,
    score1: "",
    reason: "",
    score2: "",
    remarks: ""
})

const diaRequestAccept = ref(false)
const diaSubmitreview = ref(false)

// 审稿请求的信息
const formRequestAccept = ref({
    pid: route.query.pid,
    subject: "",
    message: "",
    decision: "2"
})

// 获取论文详细信息
function getPaperDetail() {
    request.post("/paper/detail", {
        pid: route.query.pid
    }, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
        paperinfo.value = res.data
        pdf.value = paperinfo.value.paperfile+"?v="+shortid.generate()
        console.log(pdf.value,"p")
    })
}

// 获取论文建议信息
function getAdvice() {
    request.get(`/paper/getadvice?pid=${route.query.pid}`).then((res) => {
        // 进入页面获取建议
        if (res.data) {
            adviceform.value = res.data
        }
    })
}


// 预览pdf加载事件
const rendered = () => {
    loading.value = false
}

//打印PDF
const printpdf = () => {
    printJS(pdf.value)
}

//下载PDF
const download = () => {
    let acronym = route.query.acronym.split(" ").join("_")
    let autoid = paperinfo.value.autoid
    saveAs(pdf.value, `${acronym}_paper_${autoid}.pdf`)
}


// 录用论文
const hire = () => {
    request.post("/paper/decision", {
        pid: route.query.pid,
        choice: 2
    }, {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }).then((res) => {
        if (res.code == 200) {
            ElMessage({
                message: 'This paper has been accepted',
                type: 'success',
            })
            getPaperDetail()
        }else{
            ElMessage({
                message: res.msg,
                type: 'warning',
            })
        }
    })
}

// 拒稿论文
const refuse = () => {
    request.post("/paper/decision", {
        pid: route.query.pid,
        choice: 3
    }, {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }).then((res) => {
        if (res.code == 200) {
            ElMessage({
                message: 'The paper has been rejected',
                type: 'warning',
            })
            getPaperDetail()
        }
    })
}

// evaluation 分数
const value = ref('')
const cities = [
    {
        value: '3',
        label: 'strong accept',
    },
    {
        value: '2',
        label: 'accept',
    },
    {
        value: '1',
        label: 'weak accept',
    },
    {
        value: '0',
        label: 'borderline paper',
    },
    {
        value: '-1',
        label: 'weak reject',
    },
    {
        value: '-2',
        label: 'reject',
    },
    {
        value: '-3',
        label: 'strong reject',
    },
]

// confidence 分数
const value2 = ref('')
const cities2 = [
    {
        value: '5',
        label: 'expert',
    },
    {
        value: '4',
        label: 'high',
    },
    {
        value: '3',
        label: 'medium',
    },
    {
        value: '2',
        label: 'low',
    },
    {
        value: '1',
        label: 'none',
    }
]

// 展示接受审稿界面
const showDiaRequestAccept = ()=>{
    diaRequestAccept.value = true
    formRequestAccept.value.subject = `your review request for ${route.query.acronym} submission ${paperinfo.value.autoid}`
}

//审稿人： 回复审稿请求
const answerRequest = () => {
    // 效验
    if (formRequestAccept.value.subject == "" || formRequestAccept.value.message == "") {
        ElMessage({
            message: 'cannot have empty values',
            type: 'warning',
        })
        return
    }
    // 传入后端
    request.get(`/paper/accept?pid=${formRequestAccept.value.pid}&subject=${formRequestAccept.value.subject}&message=${formRequestAccept.value.message}&decision=${formRequestAccept.value.decision}`).then((res) => {
        if (res.code == 200) {
            diaRequestAccept.value = false
            ElMessage({
                message: 'reviewed',
                type: 'success',
            })
            getAdvice()
            getPaperDetail()
        }
    })
}

// 审稿人：提交论文建议
const submitAdvice = () => {
    // 效验
    if (adviceform.value.reason == null || adviceform.value.reason == '') {
        ElMessage({
            message: 'reason cannot be empty',
            type: 'warning',
        })
        return
    }
    else if (adviceform.value.score1 == null) {
        ElMessage({
            message: "evaluation reason cannot be empty",
            type: 'warning',
        })
        return
    }
    else if (adviceform.value.score2 == null) {
        ElMessage({
            message: "reviewer's confidence cannot be empty",
            type: 'warning',
        })
        return
    }
    // 传入后端
    request.post("/paper/addadvice", adviceform.value, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
        if (res.code == 200) {
            ElMessage({
                message: 'review comments submitted successfully',
                type: 'success',
            })
            diaSubmitreview.value = false
            getAdvice()
        }
        else {
            ElMessage({
                message: res.msg,
                type: 'warning'
            })
        }
    })
}

// 修改论文
const modify = () => {
    request.post("/conference/detail", {
        cid: paperinfo.value.cid
    }, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
        let conferencedetail = res.data
        router.push(`/common/createpaper?role=3&cid=${paperinfo.value.cid}&pid=${paperinfo.value.pid}&modify=1&acronym=${conferencedetail.acronym}&title=${conferencedetail.title}&subnum=${conferencedetail.subnum}`)

    })
}


// 发送邮件
const sendemail = ()=>{
    router.push(`/common/submissionemail?pid=${paperinfo.value.pid}&acronym=${route.query.acronym}&title=${paperinfo.value.title}&autoid=${paperinfo.value.autoid}`)
}
// 发送邮件
const sendemail2 = ()=>{
    router.push(`/common/reviewemail?pid=${paperinfo.value.pid}&acronym=${route.query.acronym}&title=${paperinfo.value.title}&autoid=${paperinfo.value.autoid}`)
}

onMounted(() => {
    // 获取论文消息
    getPaperDetail()
    // 获取论文建议信息
    getAdvice()
})
</script>


<style lang="scss">
.detailpaper-box {
    padding-bottom: 30px;
    position: relative;

    .office-dia {
        .vue-office-pdf-wrapper {
            padding: 0px !important;
        }
    }

    .section {
        font-weight: 700;
        font-size: 17px;
        padding: 0;
        -webkit-background-clip: text;
        background-clip: text;
        background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 41, 66));
        color: transparent;
    }

    .login-title {
        background: #b7dffd3b;
        margin-bottom: 50px;
        padding: 20px 0;
        .desc-box {
            font-size: 16px;
            padding: 0 30px;

            .title {
                font-weight: 700;
                font-size: 20px;
                padding: 0;
                -webkit-background-clip: text;
                background-clip: text;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                color: transparent;
            }

            .info {
                padding: 0;
                font-size: 14px;
                margin-bottom: 10px;
            }
        }
    }

    .my-label {
        background-color: #e9f4ff24 !important;
    }

    .el-descriptions__label {
        width: 180px !important;
    }

    .authorbtn {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin: 50px 0 20px 0;

    }

    .status {
        margin-top: 0px;
    }

    .submit {
        padding-left: 260px;
        width: 100%;

        .el-button {
            width: 300px;
        }
    }

    .reviews {
        margin-bottom: 30px;

        td {
            border: 0 !important;
        }

        .title {
            text-align: center;
            background-color: #93b5c2ba;
            padding: 2px;
            color: #f9f8f8;
        }
    }

    .msg-box {
        white-space: pre-line;
        font-size: 13px;
        padding: 12px;
        background-color: #f5f7fa9c;
        color: #337095db;
    }

    .email-item {
        background-color: #679ac314 !important;
    }

    .arq-box {
        position: absolute;
        right: -15%;
        top: 0%;
        background-color: #b7dffd3b;
        // height: 60px;
        width: 130px;
        padding: 10px;
        border-left: 3px solid #81b4db;
        border-right: 3px solid #81b4db;
        font-size: 13px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        cursor: pointer;
        color: #3a84bd;
        padding-left: 20px;
        div{
            margin-bottom:5px;
        }
    }
}
</style>